import { useMutation, useQueryClient } from '@tanstack/react-query';
import { agencyApi } from '../api/agencyApi';
import type { CreatePracticePayload } from '../api/agencyApi';
import { agencyKeys, commandCenterKeys } from '../queryKeys';

export function useCreatePractice() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreatePracticePayload) => agencyApi.createPractice(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: agencyKeys.practices() });
      queryClient.invalidateQueries({ queryKey: agencyKeys.stats() });
      queryClient.invalidateQueries({ queryKey: commandCenterKeys.all });
    },
  });
}
